import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";

const BingoCTASection = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Container maxWidth="lg">
        <Box 
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: { xs: 4, md: 8 },
            flexDirection: { xs: "column", md: "row" }
          }}
        >
          {/* Left Section - GIF */}
          <Box 
            sx={{ 
              flex: 1, 
              display: "flex", 
              justifyContent: "center",
              order: { xs: 2, md: 1 }
            }}
          >
            <Box
              component="img"
              src="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2pldWphNGt5b3dpc3BtNW1ldDVkcDQ2bGIxZWZreHdxcGRhNzF0bSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/JrXpEIKc4L7HFbbGyk/giphy.gif"
              alt="Bingo Animation"
              sx={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "16px",
                boxShadow: "0 20px 40px rgba(0,0,0,0.3)"
              }}
            />
          </Box>

          {/* Right Section - Content */}
          <Box 
            sx={{ 
              flex: 1, 
              color: "white",
              textAlign: { xs: "center", md: "left" },
              order: { xs: 1, md: 2 }
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "white",
                fontWeight: 900,
                lineHeight: 1.2,
                mb: 2,
                fontSize: { xs: "2rem", lg: "3rem" },
                textShadow: "0 2px 10px rgba(0,0,0,0.3)",
              }}
            >
              Ready to Host a Bingo Break?
            </Typography>
            <Typography
              variant="h6"
              sx={{ 
                color: "rgba(255,255,255,0.95)", 
                fontWeight: 400, 
                mb: 4,
                fontSize: { xs: "1.1rem", lg: "1.3rem" },
                lineHeight: 1.5,
                maxWidth: "500px",
                margin: { xs: "0 auto 2rem auto", md: "0 0 2rem 0" }
              }}
            >
              Create memorable moments with friends, family, or colleagues. Our interactive bingo games bring people together for laughs, prizes, and unforgettable fun!
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: { xs: "center", md: "flex-start" },
                flexWrap: "wrap",
              }}
            >
              <Button
                onClick={() =>
                  window.open("https://admin.mybingo.social/login", "_self")
                }
                sx={{
                  backgroundColor: "rgba(255,255,255,0.25)",
                  backdropFilter: "blur(15px)",
                  color: "white",
                  fontWeight: "700",
                  fontSize: "1.1rem",
                  padding: "16px 36px",
                  borderRadius: "16px",
                  border: "2px solid rgba(255,255,255,0.3)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  letterSpacing: "0.02em",
                  textTransform: "none",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.2)",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.35)",
                    transform: "translateY(-3px)",
                    boxShadow: "0 16px 48px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.3)",
                    border: "2px solid rgba(255,255,255,0.5)",
                  },
                  "&:active": {
                    transform: "translateY(-1px)",
                  },
                }}
              >
                🎯 Start Hosting Games
              </Button>
              <Button
                onClick={() => window.open("/organisers", "_self")}
                sx={{
                  backgroundColor: "transparent",
                  color: "white",
                  fontWeight: "600",
                  fontSize: "1.1rem",
                  padding: "16px 36px",
                  borderRadius: "16px",
                  border: "2px solid rgba(255,255,255,0.4)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  letterSpacing: "0.02em",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.15)",
                    transform: "translateY(-3px)",
                    border: "2px solid rgba(255,255,255,0.7)",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                  },
                  "&:active": {
                    transform: "translateY(-1px)",
                  },
                }}
              >
                👀 View Games
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default BingoCTASection;